export const playData = [
  {
    label: '日期',
    sortable: true,
    value: '0,statTime'
  },
  {
    label: '短剧ID',
    nosum: true,
    width: 100,
    value: '100,playId'
  },
  {
    label: '短剧名称',
    width: 300,
    nosum: true,
    tooltip: true,
    value: '120,playName'
  },
  {
    label: '中文短剧名称',
    width: 300,
    nosum: true,
    tooltip: true,
    value: '121,playCnName'
  },
  {
    label: '语言',
    width: 100,
    nosum: true,
    tooltip: true,
    value: '1,langName'
  },
  {
    label: '投放金额',
    width: 120,
    sortable: true,
    value: '2,cost'
  },
  {
    label: '染色人数',
    value: '3,colorationCount'
  },
  {
    label: '染色成本',
    needCalc: true,
    calc: {
      type: '/',
      data: ['cost', 'colorationCount']
    },
    value: '4,colorationCost'
  },
  {
    label: '付费率',
    value: '205,payPercent',
    needCalc: true,
    calc: {
      type: '/',
      unit: '%',
      data: ['payUserCount', 'colorationCount']
    },
    render: (h, params) => {
      return (
        <div>
          {params.row.payPercent
            ? (Number(params.row.payPercent) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '支付成功率',
    width: 120,
    needCalc: true,
    calc: {
      type: '/',
      unit: '%',
      data: ['payCount', 'orderCount']
    },
    value: '204,paySuccessPercent',
    render: (h, params) => {
      return (
        <div>
          {params.row.paySuccessPercent
            ? (Number(params.row.paySuccessPercent) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '独立付费用户数',
    value: '202,payUserCount'
  },
  {
    label: '独立用户付费成本',
    needCalc: true,
    calc: {
      type: '/',
      data: ['cost', 'payUserCount']
    },
    value: '201,payUserCost'
  },

  {
    label: '付费次数',
    width: 120,
    value: '203,payCount'
  },
  {
    label: '首日ROI',
    value: '5,firstROI',
    needCalc: true,
    calc: {
      type: '/',
      unit: '%',
      data: ['firstRecharge', 'cost']
    },
    render: (h, params) => {
      return (
        <div>
          {params.row.firstROI
            ? (Number(params.row.firstROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '3日ROI',
    needCalc: true,
    calc: {
      type: '/',
      unit: '%',
      data: ['thirdRecharge', 'cost']
    },
    value: '6,thirdROI',
    render: (h, params) => {
      return (
        <div>
          {params.row.thirdROI
            ? (Number(params.row.thirdROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '8日ROI',
    needCalc: true,
    calc: {
      type: '/',
      unit: '%',
      data: ['eighthRecharge', 'cost']
    },
    value: '7,eighthROI',
    render: (h, params) => {
      return (
        <div>
          {params.row.eighthROI
            ? (Number(params.row.eighthROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '15天ROI',
    needCalc: true,
    calc: {
      type: '/',
      unit: '%',
      data: ['fifthRecharge', 'cost']
    },
    value: '8,fifthROI',
    render: (h, params) => {
      return (
        <div>
          {params.row.fifthROI
            ? (Number(params.row.fifthROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '30天ROI',
    needCalc: true,
    calc: {
      type: '/',
      unit: '%',
      data: ['thirtyRecharge', 'cost']
    },
    value: '9,thirtyROI',
    render: (h, params) => {
      return (
        <div>
          {params.row.thirtyROI
            ? (Number(params.row.thirtyROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '60天ROI',
    needCalc: true,
    calc: {
      type: '/',
      unit: '%',
      data: ['sixtyRecharge', 'cost']
    },
    value: '10,sixtyROI',
    render: (h, params) => {
      return (
        <div>
          {params.row.sixtyROI
            ? (Number(params.row.sixtyROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  // {
  //     "label": "累计ROI",
  //     "value": '11,totalROI',
  //     render:(h,params)=>{
  //         return <div>
  //             {params.row.totalROI?(Number(params.row.totalROI)*100).toFixed(2)+'%':0}
  //         </div>
  //     }
  // },
  {
    label: '首日充值金额',
    value: '12,firstRecharge'
  },
  {
    label: '3日充值金额',
    value: '13,thirdRecharge'
  },
  {
    label: '8日充值金额',
    value: '14,eighthRecharge'
  },
  {
    label: '15日充值金额',
    value: '15,fifthRecharge'
  },
  {
    label: '30日充值金额',
    value: '16,thirtyRecharge'
  },
  {
    label: '60日充值金额',
    value: '17,sixtyRecharge'
  },
  {
    label: '3日增长倍数',
    needCalc: true,
    calc: {
      type: '/',
      data: ['thirdRecharge', 'firstRecharge']
    },
    value: '19,threeTimesGrowth'
  },
  {
    label: '8日增长倍数',
    needCalc: true,
    calc: {
      type: '/',
      data: ['eighthRecharge', 'firstRecharge']
    },
    value: '20,eightTimesGrowth'
  },
  {
    label: '15日增长倍数',
    needCalc: true,
    calc: {
      type: '/',
      data: ['fifthRecharge', 'firstRecharge']
    },
    value: '21,fifthTimesGrowth'
  },
  {
    label: '30日增长倍数',
    needCalc: true,
    calc: {
      type: '/',
      data: ['thirtyRecharge', 'firstRecharge']
    },
    value: '22,thirtyTimesGrowth'
  },
  {
    label: '60日增长倍数',
    needCalc: true,
    calc: {
      type: '/',
      data: ['sixtyRecharge', 'firstRecharge']
    },
    value: '23,sixtyTimesGrowth'
  }
  // {
  //     "label": "累计增长倍数",
  //     "value": '24,allTimesGrowth'
  // },
]
